<script lang="ts">import { onTouchOrClick } from '../../../../js-v2/onTouchOrClick';
const { openText = 'Open menu', closeText = 'Close menu', isActive = false, clickTouchFn = () => { }, } = $props();
</script>

<button type="button" class="CloseButton" use:onTouchOrClick={clickTouchFn}>
  <span class="text">
    {#if isActive}{closeText}{:else}{openText}{/if}
  </span>
  <span class="icon" aria-hidden="true">
    <span class="iconBarClockwise"></span>
    <span class="iconBarCounterwise"></span>
  </span>
</button>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.CloseButton {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, var(--color-neutral-000, #000000));
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  transition: none;
}
.CloseButton:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
.CloseButton:focus {
  background: transparent;
  outline: none;
}
.CloseButton:hover {
  background: transparent;
}

.icon {
  display: block;
  position: relative;
  width: 22px;
  height: 22px;
}

.iconBarClockwise,
.iconBarCounterwise {
  display: block;
  position: absolute;
  height: 2px;
  width: 100%;
  left: 50%;
  top: calc(50% - 1px);
  border-radius: 999em;
  background-color: var(--color-text, var(--color-neutral-000, #000000));
}

.iconBarClockwise {
  transform: translate3d(-50%, 0, 0) rotate(45deg);
}

.iconBarCounterwise {
  transform: translate3d(-50%, 0, 0) rotate(-45deg);
}

.text {
  position: absolute;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
}</style>
